import type {
  CategoryDto,
  CategoryListResponse,
  CreateCategoryRequest,
  IconUploadResponse,
  UpdateCategoryRequest,
} from '../types/categoryTypes';
import { API_BASE as BASE } from '../config';

export async function getCategories(department?: string): Promise<CategoryListResponse> {
  const url = department
    ? `${BASE}/categories?department=${encodeURIComponent(department)}`
    : `${BASE}/categories`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<CategoryListResponse>;
}

export async function getCategoryById(id: number): Promise<CategoryDto> {
  const res = await fetch(`${BASE}/categories/${id}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<CategoryDto>;
}

export async function createCategory(
  req: CreateCategoryRequest
): Promise<CategoryDto> {
  const res = await fetch(`${BASE}/categories`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<CategoryDto>;
}

export async function updateCategory(
  id: number,
  req: UpdateCategoryRequest
): Promise<CategoryDto> {
  const res = await fetch(`${BASE}/categories/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<CategoryDto>;
}

export async function deleteCategory(id: number): Promise<void> {
  const res = await fetch(`${BASE}/categories/${id}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}

export async function uploadIcon(file: File): Promise<IconUploadResponse> {
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(`${BASE}/categories/icon`, {
    method: 'POST',
    body: formData,
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<IconUploadResponse>;
}
